import type { WireEnvelope } from './types';

function uuid(): string {
  const g = globalThis.crypto;
  if (g && typeof g.randomUUID === 'function') {
    return g.randomUUID();
  }
  // Fallback(老环境):伪 UUIDv4。
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function makeEnvelope<T>(type: string, payload: T): WireEnvelope<T> {
  return { version: 1, type, event_id: uuid(), ts: Date.now(), payload };
}
